import React from 'react';

// Services
import { getEnvironmentApiUrl } from '../../../services/General';
import { getFullName } from '../../../services/getPatientAtribute';

// Hooks
import useHttp from '../../../hooks/useHttp';

// Components
import AnswersPollPatientDialog from '../AnswersPollPatientDialog/AnswersPollPatientDialog';

// Interfaces
import { AssignedInquiry, LinkedInquiry, PatientInquiryAnswer, PollQuestion } from '../../../interfaces/Poll';
import { Case, Patient } from '../../../interfaces/Patient';
interface Props {
    caseID: Case['id'],
    patient: Patient,
    patientInquiry: LinkedInquiry,
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    answerOnDemandInquiry: (assignedInquiry: AssignedInquiry) => void
}

const AnswerOnDemandInquiry: React.FC<Props> = ({
    caseID,
    patient,
    patientInquiry,
    answerOnDemandInquiry,
    setShowModal
}) => {

    const { sendRequest: createPatientInquiries } = useHttp<AssignedInquiry>();
    const { sendRequest: postAnswers } = useHttp();

    const handleClickSend = (questions: PollQuestion[]) => {

        const date = new Date().toISOString();

        createPatientInquiries({
            url: getEnvironmentApiUrl() + 'patient_inquiries',
            method: 'POST',
            body: {
                assigned_date: date,
                case_id: caseID,
                created_at: date,
                deleted_at: null,
                filled_date: null,
                inquiry_id: patientInquiry.inquiry_id,
                patient_id: patient.id,
                updated_at: date
            }
        }, (assignedInquiry) => {
            const returnedAnswers: PatientInquiryAnswer[] = [];
            questions.forEach(question => {
                const answer = question.answers.find(answer => answer?.inquiry_question_id === question.id);
                returnedAnswers.push({
                    answer: {
                        description: answer?.description ?? '',
                        emoji: '',
                        id: answer?.id,
                        inquiry_question_id: answer?.inquiry_question_id,
                        order: answer?.order ?? 0,
                        value: answer?.value,
                    },
                    carer_id: null,
                    date,
                    free_description: answer?.description,
                    inquiry_answer_id: answer?.id || null,
                    patient_id: patient.id,
                    patient_inquiries_id: assignedInquiry.id,
                });
            });
            postAnswers({
                url: getEnvironmentApiUrl() + 'inquiry/fill',
                method: 'POST',
                body: returnedAnswers,
            }, () => {
                answerOnDemandInquiry({
                    ...assignedInquiry,
                    filled_date: date,
                    inquiry: patientInquiry.inquiry
                });
                setShowModal(false);
            });
        })

    };

    return (
        <AnswersPollPatientDialog
            patientName={getFullName(patient)}
            pollID={patientInquiry.inquiry_id}
            handleClickSend={handleClickSend}
            closeModal={() => setShowModal(false)}
        />
    );
};

export default AnswerOnDemandInquiry;